var keyMirror = require('react/lib/keyMirror');

module.exports = {
    api: keyMirror({
        CHECK_COUPON: null,
        CHECK_USERNAME: null,
        CLIENT_OUDATED: null,
        CREATE_TOKEN: null,
        DELETE_SERVICE_EMAIL: null,
        DELETE_TOKEN: null,
        DOMAIN_LIST: null,
        DNS_CHECK_HOST: null,
        DNS_PTR: null,
        GET_CPANEL_LOGIN_URL: null,
        GET_FILTERED_LEGACY_INVOICES: null,
        GET_INVOICES: null,
        GET_PLANS: null,
        GET_SERVICES: null,
        HOSTING_CHECK_PASSWORD: null,
        INVOICE_PAY: null,
        PARTNER_GET: null,
        PARTNER_AUTH: null,
        PARTNER_DEAUTH: null,
        PAY_CARD: null,
        PAY_TOKEN: null,
        PAYMENT_TAKEN: null,
        SERVICE_EMAIL_CREATE: null,
        SERVICE_EMAIL_PASSWORD: null,
        SERVICE_PASSWORD: null,
        SERVICE_UPGRADE: null,
        SERVICE_UPGRADE_OPTIONS: null,
        SIGNUP_CHECK_EMAIL: null,
        SIGNUP_CREATE: null,
        SIGNUP_PAY: null,
        SIGNUP_PROCESS: null,
        SUPPRESSED_EMAILS_LIST: null,
        SUPPRESSED_EMAILS_UPDATE: null,
        UPDATE_BANDWIDTH_CURRENT: null,
        UPDATE_BANDWIDTH_HISTORY: null,
        UPDATE_TOKEN: null,
        WEBSITE_LIST: null
    }),
    auth_api: keyMirror({
        DEAUTH: null,
        MODIFY_AUTH: null,
        AUTH: null,
        GET_USER: null,
        REFRESH_HMAC: null
    }),
    bandwidth: keyMirror({
        DOWNLOAD: null,
        OFFPEAK: null,
        PEAK: null,
        UPLOAD: null
    }),
    client_service: keyMirror({
        UPGRADE: null
    }),
    request: keyMirror({
        DENIED: null,
        ERROR: null,
        FINISHED: null,
        PENDING: null,
        TIMEOUT: null
    }),
    RPP: 30,
    store: keyMirror({
        CLEAR: null
    })
};



// WEBPACK FOOTER //
// ./app/constants/Constants.js